<template>
    <div class="clinic-list-section">
        <!-- 7临床招募 -->
        <van-row
            class="clinic-list-section-box"
            style=""
            @click="goDetail(dataItem)"
        >
            <div class="clinic-list-title">
                <span>临床招募</span>
                {{
                    dataItem.content.title.length > 34
                        ? dataItem.content.title.substr(0, 34) + '...'
                        : dataItem.content.title
                }}
            </div>
            <div class="clinic-list-desc">
                {{
                    dataItem.content.desc.length > 26
                        ? dataItem.content.desc.substr(0, 26) + '...'
                        : dataItem.content.desc
                }}
            </div>
            <div class="clinic-list-tags">
                <span v-for="(val, index) in dataItem.content.tags_list" :key="index">#{{ val.name }}</span>
            </div>
        </van-row>
    </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
    props: {
        dataItem: {
            type: Object,
            required: true
        },
        contentType: {
          type: Number,
          default: 0
        },
        searchText: {
          type: String,
          default: ''
        }
    },
    methods: {
      goDetail(dataItem) {
        this.$router.push({ name: 'clinic-detail', params: { id: dataItem.content.id } })
        Interface.getData('get', `/course-phase/api/recommend_v2/${dataItem.id}/view`)
        Interface.mFootPrint(dataItem.id,67,this.contentType,1,0,0,0,dataItem.content.title, this.searchText)
      }
    }
}
</script>

<style lang="scss" scoped>
.clinic-list-section {
    // padding-bottom: 0;
    // padding: 0 12px 15px;
    border-bottom: 1px solid #f2f2f2;
    padding: 10px 12px;
    background-color: #ffffff;
    margin: 10px 10px;
    border-radius: 10px;

    &-box {
        width: 345px;
        border-bottom: 1px solid #f2f2f2;
        // padding: 0px 10px;

        &:nth-last-child(1) {
            border: 0;
        }
    }

    &-left {
        width: 112px;
        height: 66px;
        float: left;
        position: relative;
        border-radius: 6px;
        &-img {
            width: 112px;
            height: 66px;
            background: #eff3fa;
            border-radius: 6px;
            >>> .van-image__img,
            img {
                border-radius: 6px;
            }
        }
        &-zl {
            position: absolute;
            top: 0;
            left: 0;
            background: #10c3b5;
            border-radius: 6px 3px 3px 3px;
            font-family: PingFangSC-Medium;
            font-size: 10px;
            color: #ffffff;
            letter-spacing: 0;
            padding: 1px 6px;
            &.active {
                background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
                border-radius: 6px 3px 3px 3px;
            }
            img {
                width: 32px;
                height: 18px;
            }
        }
    }

    &-right {
        float: left;
        margin-left: 14px;
        width: 219px;
        text-align: left;

        &-time {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #0fb7ad;
            letter-spacing: 0;

            background: #e6fdf6;
            border-radius: 4px;
            display: inline-block;
            padding: 2px 6px;
        }

        &-title {
            font-family: PingFangSC-Medium;
            font-size: 15px;
            color: #222222;
            letter-spacing: 0;
            font-weight: 500;
            margin-top: 6px;
            .light {
                color: #0fb7ad;
            }
        }

        &-detail {
            margin-top: 17px;
            width: 100%;
            font-size: 12px;
            color: #979799;

            div {
                display: inline-block;
            }
        }
    }

    .clinic-list-title {
        font-family: PingFangSC-Medium;
        font-size: 15px;
        color: #222222;
        letter-spacing: 0;
        span {
            background: #10c3b5;
            border-radius: 3px;
            font-family: PingFangSC-Medium;
            font-size: 10px;
            color: #ffffff;
            letter-spacing: 0;
            padding: 1px 5px;
            margin-right: 6px;
            display: block;
            float: left;
        }
    }

    .clinic-list-title,
    .clinic-list-tags {
        padding-right: 14px;
    }

    .clinic-list-desc {
        margin-top: 6px;
        font-family: PingFangSC-Regular;
        font-size: 13px;
        color: #404040;
        letter-spacing: 0;
    }

    .clinic-list-tags {
        margin-top: 11px;
        span {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #4378d4;
            letter-spacing: 0;
            margin-right: 8px;
        }
    }

    .clinic-list-desc {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #777777;
    }

    .clinic-list-section {
        .clinic-list-tags {
            span {
                font-size: 12px;
                font-family: HarmonyOS_Sans_SC;
                color: #0cc4b9;
                line-height: 17px;
            }
        }
    }

    .course-list-section-right {
        width: 191px;
        margin-left: 10px;
    }
    .course-list-section-left {
        width: 130px;
        height: 73px;
    }
    .course-list-section-left-top {
        position: absolute;
        top: 4px;
        left: 2px;
        width: 18px;
        height: 18px;
        border-radius: 3px;
        img {
            width: 18px;
            height: 18px;
            border-radius: 3px;
        }
    }
    .course-list-section-left-zl {
        top: 4px;
        left: 4px;
        border-radius: 3px;
        background: linear-gradient(90deg, #faedd4 0%, #f0dbb6 100%);
        border-radius: 3px;
        font-size: 11px;
        font-family: HarmonyOS_Sans_SC_Bold;
        color: #976730;

        &.play {
            width: 36px;
            height: 36px;
            border-radius: 100%;
            background: rgba(0, 0, 0, 0.3) !important;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            box-sizing: border-box;
            padding-top: 6px;
            padding-left: 7px;
            img {
                width: 24px;
                height: 24px;
                border-radius: 100%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/contentSelection/modules/clinic.vue